import { DRIVERS } from "../const/actionTypes";
import { postAjax, putAjax, deleteAjax } from "../../auth/ApiAuth";
import { getStudentIds, getStudentsByIds } from "../../api/users";
import { setTypeCounter } from "./lessons";

const RegisterData = {
    username: '',
    password1: '',
    password2: '',
    email: '',
}

export const setDrivers = item => {
    return {
        type: DRIVERS.SET_DRIVERS,
        item
    }
}

export const editDriver = (editedDriverData) => ({
    type: DRIVERS.EDIT_DRIVER,
    editedDriverData
})

const clearDrivers = () => ({
    type: DRIVERS.CLEAR_DRIVERS
});

export const setEditedDriver = (editedDriver) => ({
    type: DRIVERS.SET_EDITED_DRIVER,
    editedDriver,
});
export const resetEditedDriver = () => ({
    type: DRIVERS.RESET_EDITED_DRIVER
})

// Loading state helper for drivers list
export const setDriversLoading = (loading) => ({
    type: DRIVERS.SET_DRIVERS_LOADING,
    loading,
});

// Deprecated: legacy non-paginated endpoint replaced by paginated aggregator
// Keeping function name out to avoid accidental usage elsewhere.

export function createDriver(RegData, driverData) {
    RegisterData.username = RegData.email.split("@")[0];
    RegisterData.password1 = RegData.password;
    RegisterData.password2 = RegData.password;
    RegisterData.email = RegData.email;
    driverData.username = driverData.email.split("@")[0];
    driverData.accountType = "student";

    return async (dispatch) => {
        async function updateEndUser(results){
            let driverId = results.user
            driverData.pk = driverId
            let baseurl = `${process.env.REACT_APP_BASE_URL}/api/user/` + driverId + '/'
            await putAjax(baseurl, driverData);
        }

        let baseurl = `${process.env.REACT_APP_BASE_URL}/rest-auth/registration/`
        await postAjax(baseurl, RegisterData, updateEndUser).catch(e => {console.log(e)});
    }
}

export function deleteDriver(driverId) {
    return async (dispatch) => {
        let baseurl = `${process.env.REACT_APP_BASE_URL}/api/user/` + driverId + '/'
        await deleteAjax(baseurl)
        // Let calling views refresh their own page slice
    }
}

export function updateDriver(RegData, driverId) {
    return async (dispatch) => {
        let baseurl = `${process.env.REACT_APP_BASE_URL}/api/user/` + driverId + '/'
        await putAjax(baseurl, RegData)
        // Let calling views refresh their own page slice
    }
}

export function getAllDrivers(filters = {}) {
    return async (dispatch) => {
        // indicate loading and reset state before streaming in pages
        dispatch(setDriversLoading(true));
        dispatch(clearDrivers());
        try {
            const idsResp = await getStudentIds({ is_active: filters.is_active ?? true });
            const allIds = idsResp && Array.isArray(idsResp.ids) ? idsResp.ids : [];
            if (allIds.length === 0) {
                dispatch(setDrivers([]));
            } else {
                const resp = await getStudentsByIds(allIds);
                const items = Array.isArray(resp?.results) ? resp.results : (Array.isArray(resp) ? resp : []);
                dispatch(setDrivers(items));
                if (filters.startDate && filters.endDate) {
                    dispatch(setTypeCounter('student', items));
                }
            }
        } catch (err) {
            console.log(err);
        } finally {
            dispatch(setDriversLoading(false));
        }
    }
}

export default (
    setDrivers,
    editDriver,
    setEditedDriver,
    getAllDrivers,
    createDriver,
    resetEditedDriver,
    setDriversLoading,
    updateDriver,
    deleteDriver
)
